<template>
	<div v-if="dati" style="display: flex; width: 100%; flex-wrap: wrap">
		<div v-if="dati.wiki && logged" class="wiki-button">
			<wiki-button :item="{ val: dati.wiki }"></wiki-button>
		</div>

		<div style="display: flex; width: 100%; flex-wrap: wrap" :key="chiave" v-if="shouldBeShown">
			<Renderer
				:toggleBorders="toggleBorders"
				v-if="dati.value"
				@show="() => showME()"
				:key="dati.id + chiave"
				:valore="dati"
				:dati="[dati.value[0]]"
				:logged="logged"
			></Renderer>

			<base-renderer
				@end="
					() => {
						$emit('end')
					}
				"
				@end2="
					val => {
						$emit('end2', val)
					}
				"
				style="display: flex; width: 100%; flex-wrap: wrap"
				:key="dati.id + chiave + shouldBeShown"
				v-if="selected !== undefined"
				:toggleBorders="toggleBorders"
				:chiave="dati.id + chiave + uuid() + selected + uuid() + shouldBeShown + dati.id * 86"
				:dati="computedData"
				:logged="logged"
			></base-renderer>
		</div>
		<div style="display: flex; width: 100%; flex-wrap: wrap" :key="dati.id + 96" v-else>
			<Renderer
				class="nodes"
				v-if="dati.value"
				@show="() => showME()"
				:key="dati.id + chiave + 654"
				:valore="dati"
				:dati="[dati.value[0]]"
				:toggleBorders="toggleBorders"
				:logged="logged"
			></Renderer>

			<base-renderer
				style="display: flex; width: 100%; flex-wrap: wrap"
				@end="
					() => {
						$emit('end')
					}
				"
				@end2="
					val => {
						$emit('end2', val)
					}
				"
				v-if="show"
				:key="dati.id + chiave + uuid() + shouldBeShown"
				:toggleBorders="toggleBorders"
				:chiave="dati.id + chiave + uuid() + shouldBeShown"
				:dati="dati.children[0]"
				:logged="logged"
			></base-renderer>
		</div>
	</div>
</template>
<script>
import { uuid } from "@/modules/builder/utils/utils"
import RawDisplayer from "@/modules/builder/components/raw-displayer"
import { mapGetters, mapMutations } from "vuex"
import WikiButton from "@/modules/flowcharts/components/wiki-button"
/*
 * spiegazione rapida del file
 *
 * base-renderer prende in ingresso l'alberatura creata da flat-renderer e la discende dal primo elemento,
 * la logica base, che trovi anche sul file salvato nella lavagna, in pratica è questa:
 * se è una domanda, renderizza il contenuto del blocco, dopodichè chiama sè stesso passandosi il nodo successivo, ricavato dalla proprietà computed che si basa sulla risposta alla domanda data da fill-layout.
 * l'aggiornamento è automatico quando cambia la risposta
 *
 * se il nodo corrente non è una domanda, o è un nodo foglia, renderizzo comunque il contenuto e chiamo base-renderer con il primo figlio, se base-renderer al mount trova che i dati passati sono vuoti si blocca e non prosegue con il render, generando un emit di fine
 *
 *
 *
 *
 *
 * */
export default {
	name: "base-renderer",
	props: ["dati", "chiave", "toggleBorders", "logged"],
	components: {
		WikiButton,
		RawDisplayer,
		Renderer: () => import("@/modules/builder/components/Renderer")
	},
	data() {
		return {
			show: false,
			next: undefined,

			varVal: undefined
		}
	},

	computed: {
		...mapGetters({
			mySubscription: "organization/active_subscription",
			sidebar_status: "documents/sidebar",
			element: "compilation/selected",
			selected_value: "compilation/selected_value"
		}),

		actual_element() {
			return this.element(this.dati.id)
		},
		selected() {
			return this.selected_value(this.dati.id) !== null ? this.selected_value(this.dati.id) : null
		},
		computedData() {
			if (this.selected) {
				return this.dati.children.find(x => x.id === this.selected)
			}
		},

		shouldBeShown() {
			if (this.dati.question) {
				return this.dati.question.value != ""
			} else {
				return false
			}
		}
	},
	mounted() {
		if (this.dati) {
			this.$emit("end")
		} else {
			//nothing so far
		}
		this.$emit("end2", this.dati)
	},
	methods: {
		...mapMutations({
			openSidebar: "documents/TOGGLE_SIDEBAR",
			setSidebar: "documents/SIDEBAR_CONTENT"
		}),
		uuid,
		showME() {
			this.show = true
			this.$nextTick(() => {
				this.show = true
			})
		}
	} //sus
}
</script>

<style lang="css" scoped></style>
